import { createFileRoute } from "@tanstack/react-router";

import { legalRoute } from "./legal/-components/legalRoute";

export const Route = createFileRoute("/master-services-agreement")(
  legalRoute("master-services-agreement")
);
